import { Event } from '@planone/bau365/util-fair-data';

export const staticEvents: { [id: string]: Event } = {};
